import { type IPrivateCompany } from '@inpart-io/padme-iap';
import { type GetterTree } from 'vuex';

import { type IPrivateCompanyState } from './types';

export const GET_MATCHES = 'getMatches';

export const getters: GetterTree<IPrivateCompanyState, unknown> = {
    [GET_MATCHES]: (_state) => {
        return (companyId: number): IPrivateCompany[] => {
            return _state.matches.get(companyId);
        };
    }
};
